const operations = {
  request:'mutation RequestPasswordResetCode($email:String!) { requestPasswordResetCode(email:$email) { status requestId expiresIn retryAfter } }',
  verify:'mutation VerifyPasswordResetCode($requestId:String!,$code:String!) { verifyPasswordResetCode(requestId:$requestId,code:$code) { status resetToken expiresIn retryAfter } }',
  complete:'mutation CompletePasswordResetCode($requestId:String!,$resetToken:String!,$newPassword:String!) { completePasswordResetCode(requestId:$requestId,resetToken:$resetToken,newPassword:$newPassword) { status retryAfter } }',
};
const fields={request:'requestPasswordResetCode',verify:'verifyPasswordResetCode',complete:'completePasswordResetCode'};
export async function resetCodeRequest(action, variables, signal) {
  const controller=new AbortController();
  const abort=()=>controller.abort();
  signal?.addEventListener('abort',abort,{once:true});
  if(signal?.aborted)abort();
  const timeout=setTimeout(abort,20000);
  try {
    // No cached GraphQL result, JWT, cookies, query-string secrets or telemetry.
    const response=await fetch('https://gql.gpson.cz:3000/graphql',{method:'POST',headers:{'Content-Type':'application/json'},credentials:'omit',cache:'no-store',referrerPolicy:'no-referrer',signal:controller.signal,body:JSON.stringify({query:operations[action],variables})});
    if(!response.ok)throw new Error();
    const payload=await response.json();
    if(payload.errors?.length || !payload.data?.[fields[action]])throw new Error();
    return payload.data[fields[action]];
  } catch(error) {
    if(signal?.aborted)throw error;
    throw new Error('Reset hesla se nepodařilo dokončit. Zkontrolujte připojení a zkuste to znovu.');
  } finally {clearTimeout(timeout);signal?.removeEventListener('abort',abort);}
}
